import { makeStyles } from "tss-react/mui";

interface IStyleParams {
    isMobile: boolean;
}

export const useStyle = makeStyles<IStyleParams>()((theme, { isMobile }) => ({
    cardContent: {
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        backgroundColor: theme.palette.background.dark,
        "&:last-child": {
            paddingBottom: theme.spacing(2),
        },
    },
    title: {
        color: theme.palette.secondary.main,
        alignSelf: "center",
    },
    deleteButton: {
        color: theme.palette.secondary.main,
    },
    deleteButtonIcon: {
        width: 24,
        height: 24,
    },
    deleteButtonSize: {
        width: 44,
        height: 44,
        padding: theme.spacing(1.5),
    },
}));
